const lbGreen = {
  darker: '#007253',
  dark: '#018F66',
  default: '#00AA77',
  light: '#37BF77',
  lighter: '#6CD276',

  HA60: '#60C6A8',
  HA40: '#90D5C2',
  HA20: '#C0E3DA',
  HA10: '#D9EAE7',
  HA5: '#E4EDED',
};

export default lbGreen;
